import { cn } from '@/utils'

interface TourProgressProps {
  total: number
  done: number
  className?: string
}

export function TourProgress({ total, done, className }: TourProgressProps) {
  return (
    <div
      role="img"
      aria-label={`${done} of ${total} steps done`}
      className={cn('shrink-0 items-center gap-1', className)}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: the segments are positions, not items.
          key={index}
          className={cn(
            'h-1.5 w-4 rounded-full',
            index < done ? 'bg-brand' : 'bg-blue-2',
          )}
        />
      ))}
    </div>
  )
}
